/**
 * GrupoPermissaoTemplate — vínculo Grupo x Permissao (permitido/negado), relacionado de Grupo.
 *
 * Simplificado: RelatedEntityGrid genérico, sem a matriz visual de permissionamento do
 * hay-hotspot (`GrupoPermissionamentoPage`, fora do escopo desta fase — melhoria visual).
 * Permissao continua um catálogo só de leitura (ver PermissaoTemplate) restrito ao principal —
 * aqui só o vínculo permitido/negado é editável, por tenant.
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { RelatedEntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import GrupoPermissao from '../../../models/GrupoPermissao';
import Grupo from '../../../models/Grupo';
import Permissao from '../../../models/Permissao';

const model = {
  grupo: {
    exibir: 'main.grupopermissao.grupo',
    visivel: true,
    tipo: 'relacao',
    camporelacao: 'nome',
    entidade: 'grupo.entidade',
    template: 'grupo.template',
    validacao: { obrigatorio: true },
  },
  permissao: {
    exibir: 'main.grupopermissao.permissao',
    visivel: true,
    tipo: 'relacao',
    camporelacao: 'state',
    entidade: 'permissao.entidade',
    template: 'permissao.template',
    validacao: { obrigatorio: true },
  },
  permitido: { exibir: 'main.grupopermissao.permitido', visivel: true, tipo: 'boolean' },
};

const renderers = {
  'grupo.entidade': Grupo,
  'grupo.template': (rowData) => rowData.grupo?.nome || '',
  'permissao.entidade': Permissao,
  'permissao.template': (rowData) => rowData.permissao?.state || '',
};

class GrupoPermissaoFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.grupopermissao.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 md:col-6 mt-3"><ModelDropDown model={model.grupo} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelDropDown model={model.permissao} contexto={contexto} /></div>
            <div className="field col-12 mt-3"><ModelBoolean model={model.permitido} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class GrupoPermissaoTemplate extends Component {
  render() {
    return (
      <RelatedEntityGrid
        entidade={GrupoPermissao}
        model={model}
        identidade="main.grupopermissao"
        icone="pi-shield"
        permissoes={this.props.permissoes}
        storageKey="dt-grupopermissoes"
        processos={[]}
        relacionados={[]}
        renderers={renderers}
        configuracao={this.props.configuracao}
        formulario={(m, ctx) => <GrupoPermissaoFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default GrupoPermissaoTemplate;
